<template>
  <div class="participants">
    <div :class="{'participants__item_my': myStream && !captured}"
         class="participants__item"
    >
      <JanusRoomParticipantVideo v-if="myStream" :my="true"
                                 :has-video="!cameraDisabled" :fixed="fixed === 'my'" :name="name"
                                 :is-speaking="isMyStreamSpeaking"

                                 @click.native="setCurrentStream(myStream, true)"
      >
        <video v-show="!cameraDisabled || captured" ref="video" muted playsinline />
        <div class="participants__disable">
          <div v-show="cameraDisabled && !captured"
               class="participants__disable-item participants__disable-item_cam"
          />
          <div v-if="microphoneDisabled"
               class="participants__disable-item participants__disable-item_mic"
          />
        </div>
      </JanusRoomParticipantVideo>
    </div>
    <template v-if="filteredPublishers && filteredPublishers.length">
      <div
        v-for="(pub) in filteredPublishers"
        :key="pub._id" class="participants__item d-none d-xl-block"
        @click="changeStreamByMemberId(pub.data.janusRoomMemberId ,true)"
      >
        <JanusRoomParticipant :publisher="pub" :janus-room-id="pub.data.janusRoomId"
                              :janus-room-member-id="pub.data.janusRoomMemberId"
                              :janus-room-private-member-id="pub.data.janusRoomPrivateMemberId"
                              :name="pub.data.name"
                              @stream="addStream"
        />
      </div>
    </template>
  </div>
</template>

<script>
import useJanusPublisher from '@/compositions/useJanusPublisher';
import useStreams from '@/compositions/useStreams';
import JanusRoomParticipant from '@/components/VideoRoomParticipant.vue';
import { watchEffect, ref, computed } from '@vue/composition-api';
import useVideo from '@/compositions/useVideo';
import JanusRoomParticipantVideo from '@/components/VideoRoomParticipantVideo.vue';
import useCaptureScreen from '@/compositions/useCaptureScreen';

export default {
  name: 'JanusRoomParticipants',
  components: {
    JanusRoomParticipantVideo,
    JanusRoomParticipant,
  },
  setup() {
    const {
      filteredPublishers,
      name,
    } = useJanusPublisher();
    const {
      myStream,
      changeStreamByMemberId,
      setCurrentStream,
      addStream,
    } = useStreams();
    const { captured } = useCaptureScreen();
    const { setVideo } = useVideo();
    const {
      cameraDisabled,
      microphoneDisabled,
      fixed,
      audioLevel,
    } = useStreams();
    const video = ref(null);

    const { publishers: myPublisherList } = useJanusPublisher();
    const isMyStreamSpeaking = computed(() => {
      const myPub = myPublisherList.value.find((p) => p.data?.name);
      if (!myPub) return false;
      const level = audioLevel.value.find((l) => l.janusMemberId === myPub.data?.janusRoomMemberId);
      return !!(level && level.volume > 0.01);
    });

    watchEffect(async () => {
      await setVideo(myStream, video, {
        myStream: true,
      });
    });

    return {
      filteredPublishers,
      myStream,
      changeStreamByMemberId,
      setCurrentStream,
      video,
      name,
      addStream,
      captured,
      cameraDisabled,
      microphoneDisabled,
      fixed,
      isMyStreamSpeaking,
    };
  },
};
</script>

<style lang="scss" scoped>
.participants {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row-reverse;
  height: 7.5rem;
  flex-shrink: 0;
  padding: 0.5rem 0.625rem 0.25rem 8.125rem;
  text-align: right;
  overflow-x: auto;

  &__item {
    height: 100%;
    max-height: 6.875rem;
    border: 1px solid #2C2C2E;
    border-radius: 0.25rem;
    position: relative;
    background: url("../assets/img/icons/user.svg") no-repeat center;
    background-size: 20%;
    margin-left: 0.625rem;

    &.participants__item_my video {
      transform: scale(-1, 1);
    }
  }

  &__disable {
    font-size: 0.5rem;
    color: #949494;
    position: absolute;
    bottom: 0;
    left: 0.375rem;
    right: 0.375rem;
    text-align: right;
  }

  &__disable-item {
    width: 1.375rem;
    height: 1.375rem;
    display: inline-block;
    background: rgba(0, 0, 0, 0.5) no-repeat;
    margin: 3px 1px;
    border-radius: 0.25rem;
    &_mic {
      background-image: url("../assets/img/icons/mic-off.svg");
      background-position: center 0.25rem;
    }
    &_cam {
      background-image: url("../assets/img/icons/cam-off.svg");
      background-position: 0.3125rem 0.375rem;
      background-size: 60%;
    }
  }
}

@media (max-width: 1199px) {
  .participants {
    height: 14.25rem;
    padding: 5.625rem 1.25rem 1rem;

    &__item {
      max-height: 7.875rem;
      border: none;
    }
  }
}

@media (max-width: 959px) {
  .participants {
    padding: 5.625rem 1rem 1rem;
  }
}

@media only screen and (orientation: landscape) and (max-width: 959px),
only screen and (orientation: portrait) and (max-width: 959px) {
  .participants {
    height: auto;
    padding: 0;
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    z-index: 2;

    &__item {
      max-width: 8rem;
      height: auto;
    }
  }
}
</style>
